import {Card, Stack, styled} from '@mui/material';

const StyledHeader = styled(Stack)`
	flex: 1;
	flex-direction: row;
	align-items: start;
	gap: 8px;
	width: 100%;
	justify-content: space-between;
`;

const StyledCardContainer = styled(Card)`
	width: 100%;
	height: 100%;
	justify-content: space-between;
	flex-direction: column;
	padding: 16px;
	display: flex;
	gap: 16px;
	align-items: center;
`;

export {StyledCardContainer, StyledHeader};
